import {IState} from 'angular-ui-router';
import {RouterHelper} from '../dvbModules/router/route-helper-provider';
import BenutzerRS from '../core/service/BenutzerRS.rest';

schadenfaelleRun.$inject = ['RouterHelper'];

/* @ngInject */
export function schadenfaelleRun(routerHelper: RouterHelper) {
    routerHelper.configureStates(getStates());
}

function getStates(): IState[] {
    return [
        {
            name: 'schadenfaelle',
            template: '<schadenfaelle-view flex="auto" class="overflow-scroll" verantwortliche="$resolve.verantwortliche"></schadenfaelle-view>',
            url: '/schadenfaelle',
            resolve: {
                verantwortliche: getPossibleVerantworltiche
            }
        },

    ];
}

getPossibleVerantworltiche.$inject = ['BenutzerRS'];
/* @ngInject */
export function getPossibleVerantworltiche(benutzerRS: BenutzerRS) {
    return benutzerRS.possibleVerantwortliche();
}





// WEBPACK FOOTER //
// ./src/app/schadenfaelle/schadenfaelle.route.ts